import { defineStyleConfig } from '@chakra-ui/react';

const baseStyle = {
  field: {
    w: 'full',
    p: '0 5px 0 0',
    color: '#0E151C',
    textStyle: 'b4',
    fontSize: { mobile: '16px', laptop: '18px' },
    fontFamily: 'var(--font-inter)',
    _focus: { caretColor: '#00BE85', border: 'none' },
    _placeholder: {
      textStyle: 'b4',
      fontSize: { mobile: '13px', mg: '16px', laptop: '18px' },
      color: '#6E6E6E',
    },
  },
};

export const Input = defineStyleConfig({ baseStyle });
